import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCnnComponent } from './simple-icons-cnn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCnnComponent ],
    exports:      [ SimpleIconsCnnComponent ],
    bootstrap:    []
})
export class SimpleIconsCnnModule {}
